<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-toolbar">
    <div class="dsk-cell dsk-pulse" style="width:260px;height:13px"></div>
    <div class="dsk-spacer"></div>
    <div class="dsk-btn dsk-pulse"></div>
  </div>
  <div class="dsk-tabs">
    <div class="dsk-tab dsk-pulse" style="width:110px"></div>
    <div class="dsk-tab dsk-pulse" style="width:100px"></div>
  </div>
  <div class="dsk-card-grid">
    <div class="dsk-card" *ngFor="let c of [1,2,3,4,5,6]">
      <div class="dsk-card-head dsk-pulse" style="height:140px;border-radius:0"></div>
      <div class="dsk-card-body">
        <div class="dsk-cell dsk-pulse" style="width:75%;height:15px"></div>
        <div class="dsk-cell dsk-pulse" style="width:55%;height:11px"></div>
        <div style="display:flex;gap:6px;margin-top:4px">
          <div class="dsk-chip dsk-pulse" style="width:64px;height:22px"></div>
          <div class="dsk-chip dsk-pulse" style="width:50px;height:22px"></div>
        </div>
      </div>
      <div class="dsk-card-foot">
        <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
        <div style="display:flex;gap:6px;margin-left:auto">
          <div class="dsk-pulse" style="width:28px;height:28px;border-radius:7px"></div>
          <div class="dsk-pulse" style="width:28px;height:28px;border-radius:7px"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="et-page" *ngIf="!loading">

  <div class="et-hero">
    <div class="et-hero-txt">
      <h1 class="et-hero-title">Email &amp; Notifications</h1>
      <p class="et-hero-sub">Design branded templates, see which events send automatically, and track every delivery.</p>
    </div>
    <button class="et-btn-primary" *ngIf="activePageTab === 'templates'" (click)="openCreate()">
      <mat-icon>add</mat-icon> New Template
    </button>
  </div>

  <div class="et-page-tabs">
    <button class="et-page-tab" [class.et-page-tab--active]="activePageTab === 'templates'" (click)="switchPageTab('templates')">
      <mat-icon>email</mat-icon> Templates
    </button>
    <button class="et-page-tab" [class.et-page-tab--active]="activePageTab === 'triggers'" (click)="switchPageTab('triggers')">
      <mat-icon>bolt</mat-icon> Triggers
    </button>
    <button class="et-page-tab" [class.et-page-tab--active]="activePageTab === 'logs'" (click)="switchPageTab('logs')">
      <mat-icon>history</mat-icon> Email Logs
      <span class="et-tab-badge" *ngIf="logStats.failed > 0">{{ logStats.failed }}</span>
    </button>
    <button class="et-page-tab" [class.et-page-tab--active]="activePageTab === 'smtp'" (click)="switchPageTab('smtp')">
      <mat-icon>settings</mat-icon> Delivery (SMTP)
    </button>
  </div>

  <ng-container *ngIf="activePageTab === 'templates'">

    <div class="et-filter-bar">
      <div class="et-search-wrap">
        <mat-icon class="et-search-icon">search</mat-icon>
        <input class="et-search" type="text" placeholder="Search by name, subject or category…"
               [(ngModel)]="searchText" (ngModelChange)="onSearchChange()">
      </div>
      <div class="et-filter-right">
        <select class="et-select" [(ngModel)]="filterCategory" (ngModelChange)="onCategoryChange()">
          <option value="all">All Categories</option>
          <option *ngFor="let c of categories" [value]="c">{{ c | titlecase }}</option>
        </select>
        <span class="et-count" *ngIf="!loading">{{ filtered.length }} template{{ filtered.length !== 1 ? 's' : '' }}</span>
      </div>
    </div>

    <div class="et-loading" *ngIf="loading">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Loading templates…</span>
    </div>

    <div class="et-empty" *ngIf="!loading && filtered.length === 0">
      <div class="et-empty-icon-wrap"><mat-icon>mark_email_unread</mat-icon></div>
      <p class="et-empty-title">No templates found</p>
      <p class="et-empty-sub">
        {{ searchText || filterCategory !== 'all' ? 'Try adjusting your search or filter.' : 'Create your first email template to get started.' }}
      </p>
      <button class="et-btn-primary" *ngIf="!searchText && filterCategory === 'all'" (click)="openCreate()">
        <mat-icon>add</mat-icon> Create Template
      </button>
    </div>

    <div class="et-grid" *ngIf="!loading && filtered.length > 0">
      <div class="et-card" *ngFor="let t of pagedTemplates" [class.et-card--inactive]="!t.active">

        <div class="et-card-head">
          <span class="et-badge" [style.background]="getCategoryColor(t.category) + '18'" [style.color]="getCategoryColor(t.category)">
            {{ t.category | titlecase }}
          </span>
          <label class="et-toggle" [title]="t.active ? 'Disable template' : 'Enable template'">
            <input type="checkbox" [checked]="t.active" (change)="toggleActive(t)">
            <span class="et-toggle-track"></span>
          </label>
        </div>

        <div class="et-card-name">{{ t.name }}</div>

        <div class="et-trigger-row" *ngIf="t.triggerEvent">
          <mat-icon class="et-trigger-icon">bolt</mat-icon>
          <span class="et-trigger-label">{{ getTriggerLabel(t.triggerEvent) }}</span>
          <span class="et-trigger-key">Auto-triggered</span>
        </div>
        <div class="et-trigger-row et-trigger-manual" *ngIf="!t.triggerEvent">
          <mat-icon class="et-trigger-icon">touch_app</mat-icon>
          <span class="et-trigger-label">Manual send only</span>
        </div>

        <div class="et-card-subject">
          <mat-icon>subject</mat-icon>
          <span>{{ t.subject }}</span>
        </div>

        <div class="et-card-desc" *ngIf="t.description">{{ t.description }}</div>

        <div class="et-card-params" *ngIf="getParams(t).length > 0">
          <span class="et-chip" *ngFor="let p of getParams(t)">{{ '{{' + p + '}}' }}</span>
        </div>

        <div class="et-card-footer">
          <span class="et-card-date">
            <mat-icon>schedule</mat-icon>
            {{ t.updatedAt | date:'dd MMM yyyy' }}
          </span>
          <div class="et-card-actions">
            <button class="et-icon-btn" (click)="openCardPreview(t)" title="Preview template">
              <mat-icon>visibility</mat-icon>
            </button>
            <button class="et-icon-btn" (click)="openTestSend(t)" title="Test send">
              <mat-icon>send</mat-icon>
            </button>
            <button class="et-icon-btn" (click)="openEdit(t)" title="Edit template">
              <mat-icon>edit</mat-icon>
            </button>
            <button class="et-icon-btn et-icon-btn--danger" (click)="delete(t.id, t.name)" title="Delete template">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="et-pagination" *ngIf="!loading && tmplTotalPages > 1">
      <button class="et-pg-btn" [disabled]="tmplPage === 1" (click)="tmplPage = tmplPage - 1">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="et-pg-num"
              *ngFor="let n of tmplPageNumbers"
              [class.et-pg-num--active]="n === tmplPage"
              (click)="tmplPage = n">{{ n }}</button>
      <button class="et-pg-btn" [disabled]="tmplPage === tmplTotalPages" (click)="tmplPage = tmplPage + 1">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <span class="et-pg-info">Page {{ tmplPage }} of {{ tmplTotalPages }}</span>
    </div>

  </ng-container>

  <ng-container *ngIf="activePageTab === 'triggers'">
    <p class="et-triggers-intro">
      Every automated email the system sends, grouped by area. <strong>System</strong> emails use built-in branded
      layouts; <strong>Template</strong> events can be bound to an editable template below and toggled on/off.
      <span class="et-sched-key"><mat-icon>schedule</mat-icon> = time-scheduled</span>
    </p>

    <div class="et-trig-group" *ngFor="let g of triggerCatalog">
      <div class="et-trig-group-head">
        <mat-icon>{{ g.icon }}</mat-icon> {{ g.group }}
      </div>
      <div class="et-trig-list">
        <div class="et-trig-row" *ngFor="let e of g.events">
          <div class="et-trig-main">
            <div class="et-trig-name">
              {{ e.label }}
              <mat-icon class="et-trig-sched" *ngIf="e.scheduled" title="Runs on a schedule">schedule</mat-icon>
            </div>
            <div class="et-trig-desc">{{ e.desc }}</div>
          </div>

          <ng-container *ngIf="templateForEvent(e.key) as tpl; else noTpl">
            <span class="et-trig-tpl" (click)="openEdit(tpl)" title="Edit bound template">
              <mat-icon>description</mat-icon> {{ tpl.name }}
            </span>
            <label class="et-toggle" [title]="tpl.active ? 'On' : 'Off'">
              <input type="checkbox" [checked]="tpl.active" (change)="toggleActive(tpl)">
              <span class="et-toggle-track"></span>
            </label>
          </ng-container>
          <ng-template #noTpl>
            <span class="et-trig-tag" [class.et-trig-tag--sys]="e.system">
              {{ e.system ? 'System' : 'No template' }}
            </span>
            <span class="et-trig-status et-trig-status--on"><span class="et-dot"></span> Active</span>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="activePageTab === 'logs'">

    <div class="et-stats-bar">
      <div class="et-stat">
        <div class="et-stat-val">{{ logStats.total }}</div>
        <div class="et-stat-label">Total Sent</div>
      </div>
      <div class="et-stat et-stat--success">
        <div class="et-stat-val">{{ logStats.sent }}</div>
        <div class="et-stat-label">Delivered</div>
      </div>
      <div class="et-stat et-stat--danger">
        <div class="et-stat-val">{{ logStats.failed }}</div>
        <div class="et-stat-label">Failed</div>
      </div>
      <div class="et-stat et-stat--neutral">
        <div class="et-stat-val">{{ logStats.skipped }}</div>
        <div class="et-stat-label">Skipped</div>
      </div>
    </div>

    <div class="et-analytics" *ngIf="logStats.total > 0">
      <div class="et-analytics-col">
        <div class="et-analytics-label">Delivery rate <strong>{{ logSentPct }}%</strong></div>
        <div class="et-deliverybar">
          <span class="et-deliverybar-sent" [style.width.%]="logSentPct"></span>
          <span class="et-deliverybar-fail" [style.width.%]="logFailedPct"></span>
        </div>
        <div class="et-analytics-legend">
          <span><i class="et-lg et-lg--sent"></i> Delivered {{ logStats.sent }}</span>
          <span><i class="et-lg et-lg--fail"></i> Failed {{ logStats.failed }}</span>
          <span><i class="et-lg et-lg--skip"></i> Skipped {{ logStats.skipped }}</span>
        </div>
      </div>
      <div class="et-analytics-col et-analytics-col--events" *ngIf="logEventBreakdown.length">
        <div class="et-analytics-label">Top events (loaded)</div>
        <div class="et-evrow" *ngFor="let ev of logEventBreakdown">
          <span class="et-evrow-label">{{ ev.label }}</span>
          <span class="et-evrow-bar"><span [style.width.%]="ev.pct"></span></span>
          <span class="et-evrow-count">{{ ev.count }}</span>
        </div>
      </div>
    </div>

    <div class="et-log-filter-bar">
      <button class="et-log-filter-btn" [class.active]="logFilter === 'all'" (click)="logFilter = 'all'">All</button>
      <button class="et-log-filter-btn" [class.active]="logFilter === 'sent'" (click)="logFilter = 'sent'">Sent</button>
      <button class="et-log-filter-btn" [class.active]="logFilter === 'failed'" (click)="logFilter = 'failed'">Failed</button>
      <button class="et-log-filter-btn" [class.active]="logFilter === 'skipped'" (click)="logFilter = 'skipped'">Skipped</button>
      <button class="et-btn-outline et-btn-outline--sm" style="margin-left:auto" (click)="loadLogs()">
        <mat-icon>refresh</mat-icon> Refresh
      </button>
    </div>

    <div class="et-loading" *ngIf="logsLoading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Loading logs…</span>
    </div>

    <div class="et-empty" *ngIf="!logsLoading && filteredLogs.length === 0">
      <div class="et-empty-icon-wrap"><mat-icon>inbox</mat-icon></div>
      <p class="et-empty-title">No email logs</p>
      <p class="et-empty-sub">Emails sent by the system will appear here.</p>
    </div>

    <div class="et-log-table-wrap" *ngIf="!logsLoading && filteredLogs.length > 0">
      <table class="et-log-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Recipient</th>
            <th>Subject</th>
            <th>Trigger</th>
            <th>Sent At</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of filteredLogs">
            <td>
              <span class="et-status-badge"
                    [style.background]="getStatusBg(log.status)"
                    [style.color]="getStatusColor(log.status)">
                {{ log.status }}
              </span>
              <span class="et-recalled-badge" *ngIf="log.recalled">Recalled</span>
            </td>
            <td>
              <div class="et-log-recipient">{{ log.recipientEmail }}</div>
              <div class="et-log-sub" *ngIf="log.recipientName">{{ log.recipientName }}</div>
            </td>
            <td class="et-log-subject">{{ log.subject }}</td>
            <td>
              <span class="et-log-event" *ngIf="log.triggerEvent">{{ getTriggerLabel(log.triggerEvent) }}</span>
              <span class="et-log-event et-log-event--manual" *ngIf="!log.triggerEvent">Manual</span>
            </td>
            <td class="et-log-date">{{ log.sentAt | date:'dd MMM yyyy, HH:mm' }}</td>
            <td class="et-log-actions">
              <ng-container *ngIf="recallConfirmId === log.id">
                <span class="et-recall-confirm-text">Send retraction?</span>
                <button class="et-btn-recall-confirm" (click)="recallLog(log)">Yes, Recall</button>
                <button class="et-btn-recall-cancel" (click)="cancelRecall()">Cancel</button>
              </ng-container>

              <ng-container *ngIf="recallConfirmId !== log.id">
                <button class="et-icon-btn"
                        (click)="resendLog(log)"
                        [disabled]="resendingLogId === log.id"
                        [title]="'Resend this email to ' + log.recipientEmail">
                  <mat-icon *ngIf="resendingLogId !== log.id">send</mat-icon>
                  <mat-spinner *ngIf="resendingLogId === log.id" diameter="14"></mat-spinner>
                </button>
                <button class="et-icon-btn et-icon-btn--recall"
                        (click)="confirmRecall(log)"
                        [disabled]="recallingLogId === log.id || log.recalled"
                        [title]="log.recalled ? 'Already recalled' : 'Recall this email'">
                  <mat-icon *ngIf="recallingLogId !== log.id">undo</mat-icon>
                  <mat-spinner *ngIf="recallingLogId === log.id" diameter="14"></mat-spinner>
                </button>
                <button class="et-icon-btn et-icon-btn--danger" (click)="deleteLog(log.id)" title="Remove log">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="et-log-errors" *ngFor="let log of filteredLogs">
      <div class="et-error-row" *ngIf="log.status === 'FAILED' && log.errorMessage">
        <mat-icon>error_outline</mat-icon>
        <span><strong>{{ log.recipientEmail }}</strong>: {{ log.errorMessage }}</span>
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="activePageTab === 'smtp'">

    <div class="et-smtp-card">
      <div class="et-smtp-info">
        <mat-icon>info_outline</mat-icon>
        <span>
          By default, emails use the SMTP settings from <code>application.properties</code>
          (currently Office365 at smtp.office365.com:587). Enable the override below to use a different server.
        </span>
      </div>

      <div class="et-field et-field--inline" style="margin-bottom:20px">
        <div>
          <div class="et-label">Enable SMTP Override</div>
          <div class="et-hint" style="margin:0">Use these settings instead of the application defaults</div>
        </div>
        <label class="et-toggle">
          <input type="checkbox" [(ngModel)]="smtpForm.smtpEnabled">
          <span class="et-toggle-track"></span>
        </label>
      </div>

      <fieldset class="et-smtp-fieldset" [disabled]="!smtpForm.smtpEnabled">

        <div class="et-form-row">
          <div class="et-field et-field--grow">
            <label class="et-label">SMTP Host</label>
            <input class="et-input" [(ngModel)]="smtpForm.smtpHost" placeholder="e.g. smtp.gmail.com">
          </div>
          <div class="et-field et-field--fixed">
            <label class="et-label">Port</label>
            <input class="et-input" type="number" [(ngModel)]="smtpForm.smtpPort" placeholder="587">
          </div>
        </div>

        <div class="et-form-row">
          <div class="et-field et-field--grow">
            <label class="et-label">Username / Email</label>
            <input class="et-input" [(ngModel)]="smtpForm.smtpUsername" placeholder="noreply@company.com">
          </div>
          <div class="et-field et-field--grow">
            <label class="et-label">Password</label>
            <input class="et-input" type="password" [(ngModel)]="smtpForm.smtpPassword" placeholder="Leave blank to keep existing">
          </div>
        </div>

        <div class="et-form-row">
          <div class="et-field et-field--grow">
            <label class="et-label">From Email</label>
            <input class="et-input" [(ngModel)]="smtpForm.smtpFromEmail" placeholder="hr@company.com">
          </div>
          <div class="et-field et-field--grow">
            <label class="et-label">From Name</label>
            <input class="et-input" [(ngModel)]="smtpForm.smtpFromName" placeholder="Company HR">
          </div>
        </div>

      </fieldset>

      <div class="et-smtp-footer">
        <button class="et-btn-primary" (click)="saveSmtp()" [disabled]="smtpSubmitting">
          <mat-icon *ngIf="smtpSubmitting" class="spin">sync</mat-icon>
          <mat-icon *ngIf="!smtpSubmitting">save</mat-icon>
          {{ smtpSubmitting ? 'Saving…' : 'Save SMTP Settings' }}
        </button>
      </div>
    </div>

  </ng-container>

</div>

<div class="et-modal-overlay" *ngIf="showCardPreview" (click)="showCardPreview = false"></div>
<div class="et-modal et-modal--preview" *ngIf="showCardPreview && cardPreviewTemplate">
  <div class="et-modal-header">
    <div class="et-modal-title">
      <span class="et-badge"
            [style.background]="getCategoryColor(cardPreviewTemplate.category) + '18'"
            [style.color]="getCategoryColor(cardPreviewTemplate.category)">
        {{ cardPreviewTemplate.category | titlecase }}
      </span>
      <span>{{ cardPreviewTemplate.name }}</span>
    </div>
    <button class="et-close-btn" (click)="showCardPreview = false"><mat-icon>close</mat-icon></button>
  </div>
  <div class="et-modal-subject">
    <strong>Subject:</strong> {{ cardPreviewTemplate.subject }}
    <span class="et-modal-trigger" *ngIf="cardPreviewTemplate.triggerEvent">
      <mat-icon>bolt</mat-icon> {{ getTriggerLabel(cardPreviewTemplate.triggerEvent) }}
    </span>
  </div>
  <div class="et-modal-body">
    <iframe class="et-modal-frame" [srcdoc]="cardPreviewHtml" sandbox="allow-same-origin"></iframe>
  </div>
  <div class="et-modal-footer et-modal-footer--preview">
    <button class="et-btn-outline" (click)="showCardPreview = false">Close</button>
    <div style="display:flex;gap:8px">
      <button class="et-btn-outline" (click)="showCardPreview = false; openTestSend(cardPreviewTemplate)">
        <mat-icon>send</mat-icon> Test Send
      </button>
      <button class="et-btn-primary" (click)="showCardPreview = false; openEdit(cardPreviewTemplate)">
        <mat-icon>edit</mat-icon> Edit
      </button>
    </div>
  </div>
</div>

<div class="et-overlay" *ngIf="drawerOpen" (click)="closeDrawer()"></div>
<div class="et-drawer" [class.et-drawer--open]="drawerOpen">

  <div class="et-drawer-header">
    <div class="et-drawer-title">
      <mat-icon>{{ editingId ? 'edit_note' : 'add_circle_outline' }}</mat-icon>
      <span>{{ editingId ? 'Edit Template' : 'New Email Template' }}</span>
    </div>
    <button class="et-close-btn" (click)="closeDrawer()" title="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="et-drawer-body et-editor-split">

    <!-- LEFT: form -->
    <div class="et-ed-form">
      <div class="et-form-row">
        <div class="et-field et-field--grow">
          <label class="et-label">Template Name <span class="et-req">*</span></label>
          <input class="et-input" [(ngModel)]="form.name" placeholder="e.g. Welcome Email">
        </div>
        <div class="et-field et-field--fixed">
          <label class="et-label">Category</label>
          <select class="et-input et-select-input" [(ngModel)]="form.category">
            <option *ngFor="let c of categories" [value]="c">{{ c | titlecase }}</option>
          </select>
        </div>
      </div>

      <div class="et-field">
        <label class="et-label">Subject Line <span class="et-req">*</span></label>
        <input class="et-input" [(ngModel)]="form.subject" (ngModelChange)="onHtmlChange()"
               [attr.placeholder]="'e.g. Welcome to {{companyName}}, {{firstName}}!'">
        <span class="et-hint">Use {{ '{{paramName}}' }} for dynamic values</span>
      </div>

      <div class="et-field">
        <label class="et-label">Auto-Trigger Event <span class="et-optional">(optional)</span></label>
        <select class="et-input et-select-input" [(ngModel)]="form.triggerEvent">
          <option value="">Manual send only</option>
          <option value="employee_created">Employee Created</option>
          <option value="employee_offboarded">Employee Offboarded</option>
          <option value="leave_applied">Leave Applied</option>
          <option value="leave_approved">Leave Approved</option>
          <option value="leave_rejected">Leave Rejected</option>
          <option value="attendance_regularise_applied">Regularisation Applied</option>
          <option value="attendance_regularise_approved">Regularisation Approved</option>
          <option value="attendance_regularise_rejected">Regularisation Rejected</option>
          <option value="payslip_generated">Payslip Generated</option>
          <option value="password_reset">Password Reset OTP</option>
          <option value="password_reset_by_admin">Password Reset by Admin</option>
          <option value="checkin_reminder">Check-In Reminder</option>
          <option value="checkout_reminder">Check-Out Reminder</option>
          <option value="performance_review_due">Performance Review Due</option>
        </select>
        <span class="et-hint">When set, this template fires automatically on the selected system event.</span>
      </div>

      <div class="et-field">
        <label class="et-label">Description <span class="et-optional">(optional)</span></label>
        <input class="et-input" [(ngModel)]="form.description" placeholder="Short note about this template's purpose">
      </div>

      <div class="et-field">
        <div class="et-field-header">
          <label class="et-label">HTML Body <span class="et-req">*</span></label>
          <div class="et-snippets">
            <span class="et-snippets-label">Insert:</span>
            <button class="et-snippet" *ngFor="let v of commonVariables" (click)="insertVariable(v)">{{ v }}</button>
          </div>
        </div>
        <textarea class="et-html-editor" [(ngModel)]="form.htmlBody"
                  (ngModelChange)="onHtmlChange()" rows="18"
                  spellcheck="false" placeholder="Paste or type your HTML here…"></textarea>
      </div>

      <div class="et-params-box" *ngIf="detectedParams.length > 0">
        <div class="et-params-title">
          <mat-icon>data_object</mat-icon> Detected Parameters — fill to preview
        </div>
        <div class="et-preview-params-grid">
          <div class="et-field" *ngFor="let p of detectedParams">
            <label class="et-label">{{ p }}</label>
            <input class="et-input" [(ngModel)]="previewParams[p]" [placeholder]="'Enter ' + p" (ngModelChange)="renderPreview()">
          </div>
        </div>
      </div>

      <div class="et-field et-field--inline">
        <div>
          <div class="et-label" style="margin-bottom:2px">Active</div>
          <div class="et-hint" style="margin:0">Template will be available for use when active</div>
        </div>
        <label class="et-toggle">
          <input type="checkbox" [(ngModel)]="form.active">
          <span class="et-toggle-track"></span>
        </label>
      </div>
    </div>

    <!-- RIGHT: live preview -->
    <div class="et-ed-preview">
      <div class="et-ed-preview-head">
        <span><mat-icon>visibility</mat-icon> Live preview</span>
        <button class="et-btn-outline et-btn-outline--sm" (click)="openFullPreview()">
          <mat-icon>open_in_full</mat-icon> Full screen
        </button>
      </div>
      <div class="et-subject-preview">
        <span class="et-subject-label">Subject:</span>
        <span class="et-subject-val">{{ form.subject || '(no subject)' }}</span>
      </div>
      <div class="et-frame-wrap">
        <iframe class="et-frame" [srcdoc]="previewHtml" sandbox="allow-same-origin"></iframe>
      </div>
    </div>

  </div>

  <div class="et-drawer-footer">
    <button class="et-btn-outline" (click)="closeDrawer()">Cancel</button>
    <div class="et-footer-right">
      <button class="et-btn-outline" (click)="openFullPreview()">
        <mat-icon>open_in_full</mat-icon> Full preview
      </button>
      <button class="et-btn-primary" (click)="submit()" [disabled]="submitting">
        <mat-icon *ngIf="submitting" class="spin">sync</mat-icon>
        <mat-icon *ngIf="!submitting">{{ editingId ? 'save' : 'add_circle_outline' }}</mat-icon>
        {{ submitting ? 'Saving…' : (editingId ? 'Update Template' : 'Create Template') }}
      </button>
    </div>
  </div>

</div>

<div class="et-modal-overlay" *ngIf="showPreviewModal" (click)="showPreviewModal = false"></div>
<div class="et-modal" *ngIf="showPreviewModal">
  <div class="et-modal-header">
    <div class="et-modal-title">
      <mat-icon>visibility</mat-icon>
      <span>Full Preview — {{ form.name }}</span>
    </div>
    <button class="et-close-btn" (click)="showPreviewModal = false"><mat-icon>close</mat-icon></button>
  </div>
  <div class="et-modal-subject">
    <strong>Subject:</strong> {{ form.subject }}
  </div>
  <div class="et-modal-body">
    <iframe class="et-modal-frame" [srcdoc]="previewModalHtml" sandbox="allow-same-origin"></iframe>
  </div>
</div>

<div class="et-modal-overlay" *ngIf="showTestSend" (click)="showTestSend = false"></div>
<div class="et-modal et-modal--sm" *ngIf="showTestSend">
  <div class="et-modal-header">
    <div class="et-modal-title">
      <mat-icon>send</mat-icon>
      <span>Send Test Email</span>
    </div>
    <button class="et-close-btn" (click)="showTestSend = false"><mat-icon>close</mat-icon></button>
  </div>
  <div class="et-modal-inner">

    <div class="et-field">
      <label class="et-label">Recipient Email <span class="et-req">*</span></label>
      <input class="et-input" type="email" [(ngModel)]="testSendEmail" placeholder="yourname@company.com">
    </div>

    <div class="et-preview-params-grid" *ngIf="testSendDetectedParams.length > 0" style="margin-top:16px">
      <div class="et-field" *ngFor="let p of testSendDetectedParams">
        <label class="et-label">{{ p }}</label>
        <input class="et-input" [(ngModel)]="testSendParams[p]" [placeholder]="'Enter ' + p">
      </div>
    </div>

  </div>
  <div class="et-modal-footer">
    <button class="et-btn-outline" (click)="showTestSend = false">Cancel</button>
    <button class="et-btn-primary" (click)="submitTestSend()" [disabled]="testSending">
      <mat-icon *ngIf="testSending" class="spin">sync</mat-icon>
      <mat-icon *ngIf="!testSending">send</mat-icon>
      {{ testSending ? 'Sending…' : 'Send Test' }}
    </button>
  </div>
</div>
